import React, { useState } from "react";
import "./Styling.css";
import { useNavigate } from "react-router-dom";

const reports = [
  {
    name: "Daily active users (DAUs)",
    src: "https://us.posthog.com/embedded/uGnaavT57uPcIOQCAALEwTo5ww4www?legend&detailed",
  },
  {
    name: "Unique Users By Country",
    src: "https://us.posthog.com/embedded/ZoPHa0EbJzBlkQLSusVrjAa8V7CSWA",
  },
  {
    name: "CHAT WITH DATA ERRORS",
    src: "https://us.posthog.com/embedded/zaN6TJSyQDzmS-1k-FFKrtmmIjN2Qg",
  },
  {
    name: "DAUs",
    src: "https://us.posthog.com/embedded/iRWvILDz-OhHTx7jg4YNX4hzPkbbPw?legend&detailed",
  },
  {
    name: "DAUs Based on Questions asked",
    src: "https://us.posthog.com/embedded/lgLnKLmKsiXbvQaZZzctBp52fffGBg",
  },
  {
    name: "ERROR RATE",
    src: "https://us.posthog.com/embedded/6nHpFQrjUT9xdGTsiDc3DHemd09p4g?detailed",
  },
  {
    name: "Growth accounting",
    src: "https://us.posthog.com/embedded/s4-XKZAJ0EzKgzDncAeS6m_uY680zA?legend",
  },
];

const AdvancedMetrics = () => {
  const [activeTab, setActiveTab] = useState(0); // 0: button view, 1: iframe view
  const [selectedReportIndex, setSelectedReportIndex] = useState(null);
  const navigate = useNavigate();

  const handleButtonClick = (index) => {
    setSelectedReportIndex(index);
    setActiveTab(1);
  };
    const handleBack = () => {
    navigate("/dataAnalytics");
  };

  return (
    <div className="advanced-metrics-container">
      <div className="metrics-header">
        <h2>Advanced Metrics</h2>
        <button className="back-button" onClick={handleBack}>
          ⬅ Back To Dashboard
        </button>
      </div>

      <div className="tab-header">
        <button
          className={`main-tab ${activeTab === 0 ? "active" : ""}`}
          onClick={() => setActiveTab(0)}
        >
          Analytics Buttons
        </button>
        <button
          className={`main-tab ${activeTab === 1 ? "active" : ""}`}
          disabled={selectedReportIndex === null}
          onClick={() => setActiveTab(1)}
        >
          Selected View
        </button>
      </div>

      {activeTab === 0 && (
        <div className="tabs">
          {reports.map((report, index) => (
            <button
              key={index}
              className="tab"
              onClick={() => handleButtonClick(index)}
            >
              {report.name}
            </button>
          ))}
        </div>
      )}

      {activeTab === 1 && selectedReportIndex !== null && (
        <div className="iframe-container">
          <iframe
            src={reports[selectedReportIndex].src}
            title={reports[selectedReportIndex].name}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default AdvancedMetrics;
